export default [
  "/the-best-jobs-before-college-in-west-palm-beach",
  "/the-best-jobs-that-require-no-work-experience-in-orlando",
  "/the-best-jobs-that-require-no-work-experience-in-miami",
  "/the-best-jobs-before-college-in-tampa",
  "/best-gig-economy-jobs-in-palm-beach",
  "/gig-economy-jobs-in-fort-lauderdale",
  "/81956-2",
  "/activities-for-seniors-in-philadelphia",
  "/papa-announces-appointment-of-leslie-courtney-to-lead-client-success-organization",
  "/how-to-motivate-seniors-to-participate-in-activities",
  "/the-best-jobs-before-college-in-orlando",
  "/the-best-jobs-before-college-in-miami",
  "/activities-for-seniors-in-harrisburg",
  "/best-gig-economy-jobs-in-orlando",
  "/best-gig-economy-jobs-in-miami",
  "/best-gig-economy-jobs-in-tampa",
  "/activities-for-seniors-in-chicago",
  "/best-summer-jobs-in-fort-lauderdale",
  "/best-summer-jobs-in-west-palm-beach",
  "/best-summer-jobs-in-tampa",
  "/best-summer-jobs-in-miami",
  "/best-summer-jobs-in-orlando",
  "/activities-for-seniors-in-kansas-city",
  "/activities-for-seniors-in-knoxville",
  "/activities-for-seniors-in-nashville",
  "/best-jobs-for-college-students-in-orlando",
  "/best-jobs-for-college-students-in-palm-beach",
  "/the-best-jobs-for-college-students-in-tampa",
  "/best-jobs-for-college-students-in-fort-lauderdale",
  "/best-jobs-for-college-students-in-miami",
  "/activities-for-seniors-in-lansing-michigan",
  "/the-best-part-time-jobs-in-tampa-for-college-students",
  "/activities-for-seniors-in-kalamazoo",
  "/best-part-time-jobs-in-orlando-for-college-students",
  "/the-best-part-time-jobs-in-palm-bech-for-college-students",
  "/activities-for-seniors-in-grand-rapids",
  "/the-best-part-time-jobs-in-fort-lauderdale-for-college-students",
  "/the-best-part-time-jobs-in-miami-for-college-students",
  "/celebrating-wellderly-awareness-week",
  "/activities-for-seniors-in-jacksonville",
  "/activities-for-seniors-in-orlando",
  "/best-board-games-for-seniors",
  "/recipes-you-can-cook-with-a-papa-pal",
  "/papa-visit-experience",
  "/fun-summer-activities-for-seniors",
  "/activities-for-seniors-in-sarasota",
  "/senior-activities-naples-florida",
  "/the-villages-community-florida",
  "/loneliness-emotional-condition",
  "/7-ideas-for-this-fathers-day",
  "/social-transportation-rides-seniors",
  "/activities-for-seniors-in-tampa-and-st-petersburg",
  "/outdoor-activities-in-indian-river-county-for-seniors",
  "/best-assisted-living-communities-in-florida",
  "/including-good-health-as-part-of-my-retirement-plan",
  "/best-senior-communities-in-south-florida",
  "/hand-sanitizers-helpful-harmful-may-decreasing-hand-washing",
  "/ultimate-guide-caregiver-connect-senior",
  "/preparing-loved-one-assisted-living-placement",
  "/caregivers-love-story",
  "/best-cities-seniors-florida",
  "/how-to-teach-technology-to-seniors",
  "/senior-parents-six-common-health-concerns",
  "/make-senior-living-easy-and-pleasant-by-enjoying-a-simpler-lifestyle",
  "/drive-with-a-senior-on-board",
  "/senior-activities-in-palm-beach-county",
  "/tips-older-adults-flu-season",
  "/best-yoga-exercises-seniors",
  "/snowbirds-live-good-life-letting-others-shovel-snow",
  "/activities-for-seniors-in-broward-county",
  "/seniors-find-fitness-and-fun-with-water-aerobics",
  "/when-should-seniors-stop-driving",
  "/six-fun-activities-for-you-to-do-with-a-senior",
  "/five-great-senior-exercise-and-fitness-activities",
  "/five-no-fail-art-activities-for-seniors",
  "/seniors-organizing-for-the-next-phase-of-life",
  "/getting-the-most-out-of-your-winter-holidays-shine-that-tinsel",
  "/five-ways-your-loved-one-can-benefit-from-a-papa-pal",
  "/activities-in-miami-dade-county-for-seniors",
  "/helping-seniors-deal-with-winters-seasonal-depression",
  "/do-you-have-an-elderly-parent-out-of-state",
  "/top-reasons-you-should-be-a-papa-pal-caregiver",
  "/starting-a-position-as-a-papa-pal-heres-how-to-provide-the-best-care-possible",
  "/be-proactive-for-awareness-of-alzheimers",
  "/safety-for-elderly-or-frail-seniors-who-come-to-your-home",
  "/seniors-can-make-adjustments-to-enjoy-thanksgiving",
  "/five-precautions-to-take-if-you-have-elderly-at-home",
  "/helping-a-senior-who-should-stop-driving",
  "/intergenerational-activities-help-society",
  "/helping-friend-diagnosed-chronic-disease",
  "/supporting-senior-caregivers",
  "/finding-dependable-fun-assistance",
  "/best-ways-help-seniors-aging-place",
  "/how-papa-works",
];
